/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import * as openEnums from "../../types/enums.js";
import { OpenEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export const ServerIdentityRegistrationFailureOutcome = {
  Unreachable: "unreachable",
  Refused: "refused",
} as const;
export type ServerIdentityRegistrationFailureOutcome = OpenEnum<
  typeof ServerIdentityRegistrationFailureOutcome
>;

export const ServerIdentityRegistrationFailureReason = {
  DnsError: "dns_error",
  TlsError: "tls_error",
  Timeout: "timeout",
  NetworkError: "network_error",
  RateLimited: "rate_limited",
  UpstreamUnavailable: "upstream_unavailable",
  AuthorizationRejected: "authorization_rejected",
  InvalidSuccessResponse: "invalid_success_response",
} as const;
export type ServerIdentityRegistrationFailureReason = OpenEnum<
  typeof ServerIdentityRegistrationFailureReason
>;

/**
 * A completed automatic registration failure using the bounded OAuth registration taxonomy.
 */
export type ServerIdentityRegistrationFailure = {
  /**
   * Optional upstream HTTP status.
   */
  httpStatus?: number | undefined;
  outcome: ServerIdentityRegistrationFailureOutcome;
  /**
   * Optional sanitized and truncated provider-controlled message.
   */
  providerMessage?: string | undefined;
  reason: ServerIdentityRegistrationFailureReason;
  retryable: boolean;
};

/** @internal */
export const ServerIdentityRegistrationFailureOutcome$inboundSchema:
  z.ZodMiniType<ServerIdentityRegistrationFailureOutcome, unknown> = openEnums
    .inboundSchema(ServerIdentityRegistrationFailureOutcome);

/** @internal */
export const ServerIdentityRegistrationFailureReason$inboundSchema:
  z.ZodMiniType<ServerIdentityRegistrationFailureReason, unknown> = openEnums
    .inboundSchema(ServerIdentityRegistrationFailureReason);

/** @internal */
export const ServerIdentityRegistrationFailure$inboundSchema: z.ZodMiniType<
  ServerIdentityRegistrationFailure,
  unknown
> = z.pipe(
  z.object({
    http_status: z.optional(z.int()),
    outcome: ServerIdentityRegistrationFailureOutcome$inboundSchema,
    provider_message: z.optional(z.string()),
    reason: ServerIdentityRegistrationFailureReason$inboundSchema,
    retryable: z.boolean(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "http_status": "httpStatus",
      "provider_message": "providerMessage",
    });
  }),
);

export function serverIdentityRegistrationFailureFromJSON(
  jsonString: string,
): SafeParseResult<ServerIdentityRegistrationFailure, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ServerIdentityRegistrationFailure$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ServerIdentityRegistrationFailure' from JSON`,
  );
}
